import { render, staticRenderFns } from "./hs-number.vue?vue&type=template&id=0341b399&scoped=true&"
import script from "./hs-number.vue?vue&type=script&lang=js&"
export * from "./hs-number.vue?vue&type=script&lang=js&"
import style0 from "./hs-number.vue?vue&type=style&index=0&id=0341b399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341b399",
  null
  
)

export default component.exports